export enum LanguageCode {
  FR = 'FR',
  NL = 'NL',
  EN = 'EN'
}
